/**
 * Time Configuration Constants
 * Centralized time-related constants to avoid magic numbers throughout the codebase
 */

// Time conversion constants
export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;

// Common time durations in milliseconds
export const FIVE_MINUTES_MS = 5 * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
export const TEN_MINUTES_MS = 10 * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
/** Form definition + embedded signature config (aligns with FormDataService signature cache TTL). */
export const THIRTY_MINUTES_MS = 30 * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
export const FIFTY_FIVE_MINUTES_MS = 55 * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

// Common time durations in seconds
export const FIVE_MINUTES_SECONDS = 5 * SECONDS_PER_MINUTE; // 300 seconds

// React Query default timeouts
export const DEFAULT_STALE_TIME_MS = FIVE_MINUTES_MS;
export const DEFAULT_CACHE_TIME_MS = TEN_MINUTES_MS;

// Token refresh timing
// Percentage-based refresh: refresh when 80-85% of token lifetime has elapsed
// This adapts to short-lived tokens (e.g., 10-15 minutes) better than fixed offsets
export const TOKEN_REFRESH_PERCENTAGE = 0.82; // Refresh at 82% of lifetime (18% remaining)
export const TOKEN_REFRESH_PERCENTAGE_MIN = 0.80; // Minimum: 80% (20% remaining)
export const TOKEN_REFRESH_PERCENTAGE_MAX = 0.85; // Maximum: 85% (15% remaining)

// Legacy fixed offset (kept for backward compatibility and fallback)
export const TOKEN_REFRESH_BUFFER_MS = FIVE_MINUTES_MS; // Refresh 5 minutes before expiration
export const DEFAULT_TOKEN_REFRESH_TIME_MS = FIFTY_FIVE_MINUTES_MS; // Default refresh after 55 minutes

// Minimum refresh window: don't refresh if less than this time remains
// Prevents refreshing tokens that expire very soon anyway
export const MIN_REFRESH_WINDOW_MS = 30 * MILLISECONDS_PER_SECOND; // 30 seconds minimum

